import { render } from "./AlarmNotification.vue?vue&type=template&id=745b13fb&scoped=true"
import script from "./AlarmNotification.vue?vue&type=script&lang=js"
export * from "./AlarmNotification.vue?vue&type=script&lang=js"

import "./AlarmNotification.vue?vue&type=style&index=0&id=745b13fb&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-745b13fb"]])

export default __exports__